import { render, staticRenderFns } from "./PrintWorkshopByCategory.vue?vue&type=template&id=3571e9bd"
import script from "./PrintWorkshopByCategory.vue?vue&type=script&lang=js"
export * from "./PrintWorkshopByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports